<template>
    <div>

        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                 <div class="col-xl-4 col-lg-6">
                    <stats-card title="Paypal"
                                type="gradient-green"
                                sub-title="La forma más sencilla"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"></span>
                            <span class="text-nowrap"><a @click="track" href="https://www.paypal.com/donate?hosted_button_id=MPKZFYQ5GL27Y">Enlace</a></span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="Bitcoin"
                                type="gradient-red"
                                sub-title="Dirección:"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"></span>
                            <span class="text-nowrap">3Fw83op53ecCTQ8WhtPHs5H6x4DxSM6S5S</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-4 col-lg-6">
                    <stats-card title="Ethereum"
                                type="gradient-orange"
                                sub-title="Dirección:"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text mr-2">0x110409108a162602db69495E5CA23a047F3B6374</span>
                            <span class="text-nowrap mr-2"></span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow border-0">
                        <div id="map-canvas" class="map-canvas"  style="height: 600px;">
                            <p>Gymtrao es un proyecto que de momento se ofrece de forma gratuita con el fin de ayudar al máximo número de personas posible. Esto puede
                                cambiar en un futuro ya que con más y mas gente entrando los costes de mantener la plataforma aumentan.
                            </p>

                            <p>Considere realizar una aportación con lo que considere oportuno para seguir manteniendo el proyecto tal y como está.
                                También puede comprar empleando la sección de recomendados que hay en el menú de navegación. Esta sección incluye enlaces de afiliados a 
                                productos recomendados. Estos no tendrán ningún sobrecoste y estará ayudando al proyecto.
                            </p>

                            <p>En caso de que no se recaudara lo suficiente. El proyecto podría pasar a ser de pago bajo suscripción bajo previo aviso.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
      methods: {
        track() {
            this.$gtag.event("link_to_donations", {
            'event_category': "money",
            'event_label': "link_to_donations",
            'value': 1
            })
        },
    }
  }
</script>
<style>
p{  
    margin: 30px;
}
</style>
